import { gql, useQuery } from '@apollo/client';

export const GET_EMPLOYEES_WITHOUT_ACTIVE_WORKING_CONDITIONS = gql`
  query getMembersWithoutActiveWorkingConditions {
    getMembersWithoutActiveWorkingConditions {
      _id
      profile {
        displayName
      }
    }
  }
`;

export const useGetEmployeesWithoutActiveWorkingConditions = () => {
  const { data, loading } = useQuery(GET_EMPLOYEES_WITHOUT_ACTIVE_WORKING_CONDITIONS, {
    fetchPolicy: 'network-only',
  });

  return {
    employees: data?.getMembersWithoutActiveWorkingConditions || [],
    loading,
  };
};
